window.addEventListener('OpusCartChange', (event) => {
  const cart = event?.detail;
  if (!cart) return;
  let price = window.OpusConvertMoney(cart.total_price);
  const applyPrice = () => {
    const priceEls = document.querySelectorAll('.cd-layout-button-checkout .opus-price.money');
    priceEls.forEach((el) => {
      if (price && el.textContent !== price) {
        el.textContent = price;
      }
    });
  };
  applyPrice();
//   setTimeout(applyPrice, 50);
//   setTimeout(applyPrice, 500);
});